module.exports = __webpack_public_path__ + "r-v3/img/speaker_media_off_white.0caac740.svg";